import { jsx } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { Children, forwardRef, useCallback, useRef } from "react";
import { useSlotProps } from "../../base/index.js";
import { middleEllipsisName } from "./classes.js";
import { Root } from "./components/Root.js";
import { useMiddleEllipsis } from "./hooks/useMiddleEllipsis.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const MiddleEllipsis = forwardRef(function MiddleEllipsis2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: middleEllipsisName
  });
  const {
    children,
    components,
    componentsProps,
    ellipsis = `\u2026`,
    mode = "updateAfterResizing",
    testId = `${middleEllipsisName}-Root`,
    ...rest
  } = props;
  const ownerState = { ...props };
  const utilityClasses = useUtilityClasses(ownerState);
  const rTarget = useRef(null);
  const setRef = useCallback(
    (instance) => {
      if (typeof ref === "function") {
        ref(instance);
      } else if (ref) {
        ref.current = instance;
      }
      rTarget.current = instance;
    },
    [ref]
  );
  useMiddleEllipsis(rTarget, mode, ellipsis);
  const rootSlotProps = useSlotProps({
    ownerState,
    // classes and sx only to ROOT component
    externalForwardedProps: rest,
    className: utilityClasses.root,
    elementType: Root,
    externalSlotProps: componentsProps?.root,
    additionalProps: {
      as: components?.Root,
      "data-testid": testId,
      "data-tidal": "MiddleEllipsis",
      ref: setRef
    }
  });
  Children.only(children);
  return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children });
});
export {
  MiddleEllipsis
};
//# sourceMappingURL=MiddleEllipsis.js.map
